import { render } from "./ManagementsSlug.vue?vue&type=template&id=54c295ea"
import script from "./ManagementsSlug.vue?vue&type=script&lang=js"
export * from "./ManagementsSlug.vue?vue&type=script&lang=js"

import "./ManagementsSlug.vue?vue&type=style&index=0&id=54c295ea&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__